import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";

export class FirebaseGroupOrderService {
	constructor (options = {}) {
    this.database = null
    this.firebaseConfig = null
    Object.assign(this, options)

		this.onValue = (ref, ...args) => {
			return onValue(ref, ...args);
		}
  }

  getApp () {
    if (!this.firebaseApp) {
      this.firebaseApp = initializeApp(this.firebaseConfig)
    }
		return this.firebaseApp
  }

  useDatabase () {
    if (!this.database) {
      const app = this.getApp()
      this.database = getDatabase(app)
    }
    return this.database
  }

	getRef (key) {
    const db = this.useDatabase()
    return ref(db, key)
  }
}
